import {
  createApi,
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  retry,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';

const baseUrl = import.meta.env.VITE_PAYMENTS_SERVICE_URL;

const baseQuery = fetchBaseQuery({
  baseUrl,
});

function shouldRetryOnlyWhenNoHttpResponse(error: FetchBaseQueryError, attempt: number): boolean {
  const maxRetries = 3;
  if (attempt > maxRetries) return false;
  return error.status === 'FETCH_ERROR' || error.status === 'TIMEOUT_ERROR';
}

const baseQueryWithRetry: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = retry(
  async (args: string | FetchArgs, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    return result;
  },
  {
    retryCondition: (error, _args, { attempt }) => shouldRetryOnlyWhenNoHttpResponse(error as FetchBaseQueryError, attempt),
  }
);

export const cartsApi = createApi({
  reducerPath: 'cartsApi',
  baseQuery: baseQueryWithRetry,
  endpoints: () => ({}),
});
